module.exports = __webpack_public_path__ + "img/新闻图片2.6f7e1f87.png";